import { KeyParagraphModel } from "../../desktop/models/key-paragraph";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: KeyParagraphModel
})
export class KeyParagraphCollection extends Backbone.Collection<KeyParagraphModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/key-paragraphs.ts